var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.838 10.113a.623.623 0 00-.885.003.626.626 0 00.003.884 5.627 5.627 0 011.669 4c0 .762-2.194 1.875-5.625 1.875S4.375 15.762 4.375 15a5.625 5.625 0 011.644-3.981.625.625 0 000-.882.625.625 0 00-.881 0A6.825 6.825 0 003.125 15c0 2.031 3.544 3.125 6.875 3.125s6.875-1.094 6.875-3.125a6.837 6.837 0 00-2.037-4.887z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.625a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zm0-7.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/userIcon.369a9e21.svg";
export { MemoForwardRef as ReactComponent };